"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_RESPONSE_KEY = void 0;
exports.handleOidcCallback = handleOidcCallback;
var StateData_1 = require("./StateData");
var GLOBAL_CONTEXT_KEY = "__oidc-spa.handleOidcCallback.globalContext";
(_a = window[GLOBAL_CONTEXT_KEY]) !== null && _a !== void 0 ? _a : (window[GLOBAL_CONTEXT_KEY] = {
    previousCall: undefined
});
var globalContext = window[GLOBAL_CONTEXT_KEY];
function handleOidcCallback() {
    if (globalContext.previousCall !== undefined) {
        return globalContext.previousCall;
    }
    return (globalContext.previousCall = handleOidcCallback_nonMemoized());
}
exports.AUTH_RESPONSE_KEY = "oidc-spa.authResponse";
function handleOidcCallback_nonMemoized() {
    var e_1, _a;
    var locationUrl = new URL(window.location.href);
    var stateQueryParamValue = (function () {
        var stateQueryParamValue = locationUrl.searchParams.get("state");
        if (stateQueryParamValue === null) {
            return undefined;
        }
        if (!(0, StateData_1.getIsStatQueryParamValue)({ maybeStateQueryParamValue: stateQueryParamValue })) {
            return undefined;
        }
        if (locationUrl.searchParams.get("client_id") !== null &&
            locationUrl.searchParams.get("response_type") !== null &&
            locationUrl.searchParams.get("redirect_uri") !== null) {
            // NOTE: We are probably in a Keycloakify theme and oidc-spa was loaded by mistake.
            return undefined;
        }
        return stateQueryParamValue;
    })();
    if (stateQueryParamValue === undefined) {
        var backForwardTracker = readBackForwardTracker();
        if (backForwardTracker !== undefined) {
            writeBackForwardTracker({
                backForwardTracker: __assign(__assign({}, backForwardTracker), { hasExitedCallback: true })
            });
        }
        return { isHandled: false };
    }
    var isHandled = true;
    console.log = function () { };
    console.warn = function () { };
    console.error = function () { };
    console.debug = function () { };
    var stateData = (0, StateData_1.getStateData)({ stateQueryParamValue: stateQueryParamValue });
    if (stateData === undefined ||
        (stateData.context === "redirect" && stateData.hasBeenProcessedByCallback)) {
        reloadOnRestore();
        var historyMethod = (function () {
            var backForwardTracker = readBackForwardTracker();
            if (backForwardTracker === undefined) {
                return "back";
            }
            if (!backForwardTracker.hasExitedCallback) {
                return backForwardTracker.previousHistoryMethod;
            }
            switch (backForwardTracker.previousHistoryMethod) {
                case "back":
                    return "forward";
                case "forward":
                    return "back";
            }
        })();
        writeBackForwardTracker({
            backForwardTracker: {
                previousHistoryMethod: historyMethod,
                hasExitedCallback: false
            }
        });
        window.history[historyMethod]();
        return { isHandled: isHandled };
    }
    var authResponse = {};
    try {
        for (var _b = __values(locationUrl.searchParams), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            authResponse[key] = value;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    switch (stateData.context) {
        case "iframe":
            parent.postMessage(authResponse, location.origin);
            break;
        case "redirect":
            reloadOnRestore();
            (0, StateData_1.markStateDataAsProcessedByCallback)({ stateQueryParamValue: stateQueryParamValue });
            clearBackForwardTracker();
            sessionStorage.setItem(exports.AUTH_RESPONSE_KEY, JSON.stringify(authResponse));
            location.href = (function () {
                if (stateData.action === "login" && authResponse.error === "consent_required") {
                    return stateData.redirectUrl_consentRequiredCase;
                }
                return stateData.redirectUrl;
            })();
            break;
    }
    return { isHandled: isHandled };
}
function reloadOnRestore() {
    document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "visible") {
            location.reload();
        }
    });
}
var _b = (function () {
    var BACK_NAVIGATION_TRACKER_KEY = "oidc-spa.callback-back-forward-tracker";
    function writeBackForwardTracker(params) {
        var backForwardTracker = params.backForwardTracker;
        sessionStorage.setItem(BACK_NAVIGATION_TRACKER_KEY, JSON.stringify(backForwardTracker));
    }
    function readBackForwardTracker() {
        var raw = sessionStorage.getItem(BACK_NAVIGATION_TRACKER_KEY);
        if (raw === null) {
            return undefined;
        }
        return JSON.parse(raw);
    }
    function clearBackForwardTracker() {
        sessionStorage.removeItem(BACK_NAVIGATION_TRACKER_KEY);
    }
    return { writeBackForwardTracker: writeBackForwardTracker, readBackForwardTracker: readBackForwardTracker, clearBackForwardTracker: clearBackForwardTracker };
})(), writeBackForwardTracker = _b.writeBackForwardTracker, readBackForwardTracker = _b.readBackForwardTracker, clearBackForwardTracker = _b.clearBackForwardTracker;
//# sourceMappingURL=handleOidcCallback.js.map